import { render, staticRenderFns } from "./BuyerIoColumn.vue?vue&type=template&id=10291836&"
import script from "./BuyerIoColumn.vue?vue&type=script&lang=js&"
export * from "./BuyerIoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports